import {useState} from 'react'

import {HProduceTask, TaskSource} from '../../types'

import {CreateProcessWorkOrderContainer} from './CreateProcessWorkOrderContainer'

type Props = {
  onClose: (original?: HProduceTask, next?: HProduceTask) => void
}

export const TaskCreateFactory = ({onClose}: Props) => {
  const [taskType, setTaskType] = useState<TaskSource | undefined>(TaskSource.PROCESS_WORK_ORDER)

  switch (taskType) {
    case TaskSource.PROCESS_WORK_ORDER: {
      return (
        <CreateProcessWorkOrderContainer
          onCancel={() => onClose()}
          onSubmit={(next) => onClose(undefined, next)} // Note: 'next' is a PWO service response
          onTaskTypeChange={setTaskType}
        />
      )
    }

    default: {
      return <div>Not implemented</div>
    }
  }
}
